module.exports = __webpack_public_path__ + "img/explore_01.4e2df0fe.jpg";